
export class ValueDisplayString {
    public display: string;
    public value: string;
}